export default {
  // 欢迎信息
  welcome: {
    title: 'Welcome back!',
    greeting: '👋',
  },
  
  // 按钮
  buttons: {
    createCampaign: 'Create a campaign',
  },
  
  // 页面标题
  titles: {
    yourCampaign: 'Your Campaign',
    campaignActions: 'Campaign actions',
    campaignName: 'Campaign name',
  },
  
  // 你的活动标签页
  yourCampaignTabs: {
    reviewQuotedInfluencers: 'Review quoted influencers',
    shipProduct: 'Ship product',
    approveDelivery: 'Approve delivery',
    completeCollaboration: 'Complete collaboration',
    renewCampaign: 'Renew campaign',
    reviewTimelineExtension: 'Review timeline extension',
    confirmInviteList: 'Confirm invite list',
    influencerAccessSetup: 'Influencer access setup',
    counterOfferUnderAdvertiserReview: 'Review rates',
    selectFromAhaPicks: 'Select from Aha Picks',
    selectFromAhaPicksTooltip: 'Curated from Aha’s registered influencer pool, these influencers enable faster collaboration and more reliable fulfillment. Once confirmed, Aha will invite them to submit a quotation.',
  },

  // 文案
  messages: {
    confirmCollaborationTip:
      "Promptly approving applications helps secure influencers' schedules and enhances collaboration success rates, while delayed feedback increases the risk of influencer ghosting.",
    noPendingActions: 'Great job! You have no pending actions.',
    selectCampaignName: 'Please select campaign name',
    selectFromAhaPickTip: 'The faster you review, the faster we can send the next batch.',
    confirmCollaborationAlertTip: "Timely responses help secure influencers' schedules and reduce drop-off.",
  },

  // 充值横幅
  rechargeBanner: {
    depositNow: 'Deposit funds now and get extra ad credits',
    depositWithAmounts: 'Deposit {amount} now, get {credits} in ad credit',
    depositButton: 'Deposit funds now',
  },

  // 帮助区块
  help: {
    title: 'We are here to help',
    contact: 'Contact your AhaCreator support',
    desc: 'You have access to our specialized support service.',
  },

  // 资源卡片
  resources: {
    title: 'Resources',
    cardTitle: 'AhaCreator best practices in creativity',
    cardDesc:
      'Learn the best practices for creating attractive and impactful advertising promotions on AhaCreator.',
  },

  // 报告区块
  report: {
    selectCampaign: 'Select campaign',
  },
  
  // 状态和消息
  status: {
    creating: 'Creating...',
  },
  
  // 错误消息
  errors: {
    createCampaignFailed: 'Failed to create campaign',
  },

  // home 通知条
  notification: {
    DMtitle: 'Message Feature Update',
    DMcontent: 'We’ve heard your feedback and are upgrading the Message feature to enhance your communication experience. The feature will be temporarily unavailable starting October 17. Once an influencer’s application is approved, you can still contact them via the email address shown on the collaboration detail page. We’ll notify you as soon as the improved version is live. Thank you for your understanding and continued support!',
  },
};
